import React from 'react';
import ServicePageLayout from './service/ServicePageLayout';
import residentLandlinePageData from '../data/servicePages/residentLandline';

const ResidentLandlinePage = () => <ServicePageLayout data={residentLandlinePageData} />;

export default ResidentLandlinePage;
